import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { apiSearch } from 'helpers/decorators/api'
import { Table, Data } from 'components/layout/Table'
import { SearchResult } from 'components/misc'
import { search as searchConstants } from 'constants/layout'
import { meta } from 'helpers/decorators'

@apiSearch()
@meta({
  title: 'Search Results',
  intlKey: 'pageTitle.search_results'
})
class SearchResults extends Component {
  static propTypes = {
    search: PropTypes.object.isRequired
  }

  render() {
    const { search } = this.props

    return (
      <div>
        <h1>
          <FormattedMessage
            id="pageTitle.search_results"
            defaultMessage="Search Results"
          />{' '}
          (
          {!search.isLoading ? search.data.length : 0}
          )
        </h1>
        <Table
          loading={search.isLoading}
          length={search.data.length}
          offset={search.offset}
          limit={search.limit}
          pages={search.pages}
          ths={searchConstants.ths}
        >
          <Data>
            {search.data.map(result => (
              <SearchResult
                key={result.type + result.id}
                id={result.id}
                value={result.value}
                email={result.email}
                param={result.param1}
                type={result.type}
              />
            ))}
          </Data>
        </Table>
      </div>
    )
  }
}

export default SearchResults
